import toast from "react-hot-toast";
import { CommonService } from "../../utils/common.services";
import {
  GET_API_CALL,
  POST_API_CALL,
  DELETE_API_CALL,
  PUT_API_CALL,
} from "../../utils/services";
import { ENDPOINTS } from "../../utils/endPoints";
import { FOLDER_TYPE } from "../../utils/contentTypes";
import { createParams } from "../../utils/commonFunctions";
import {
  UPDATE_HOW_TO_VIDEOS_LIST,
  UPDATE_HOW_TO_VIDEOS_LOADING,
} from "../../store/actionTypes";

export const getHowToVideosList = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_HOW_TO_VIDEOS_LOADING });

    const { pageNo, limit } = getState().HowToVideosReducer;
    const params = createParams({
      pageNo,
      limit,
    });

    GET_API_CALL(ENDPOINTS.HOW_TO_VIDEOS.GET_LIST, params, (response) => {
      console.log("How To Videos List Response :", response);
      if (response.isSuccess) {
        const { data = [], total = 0 } = response?.data || {};
        const totalPages = Math.ceil(total / limit) || 0;
        dispatch({
          type: UPDATE_HOW_TO_VIDEOS_LIST,
          payload: {
            howToVideosList: data,
            total,
            totalPage: totalPages,
          },
        });
      }
      dispatch({ type: UPDATE_HOW_TO_VIDEOS_LOADING });
    });
  };
};

export const deleteHowToVideo = (howToUseId) => {
  return (dispatch) => {
    const toastId = toast.loading("Deleting how-to video...");
    const endpoint = `${ENDPOINTS.HOW_TO_VIDEOS.DELETE}?howToUseId=${howToUseId}`;

    DELETE_API_CALL(endpoint, (response) => {
      console.log("deleteHowToVideo response :", response);
      if (response.isSuccess) {
        toast.success(response?.data?.message || "Deleted successfully!", {
          id: toastId,
        });
        dispatch(getHowToVideosList());
      } else {
        toast.dismiss(toastId);
      }
    });
  };
};

export const HowToVideosService = {
  createHowToUsePost: async ({ title, video, thumbnail , status }) => {
    const toastId = toast.loading("Creating how-to video...");
    try {

      const [videoUrl, thumbnailUrl] = await Promise.all([
        CommonService.uploadFileAndGetUrl(
          video,
          FOLDER_TYPE.HOW_TO_VIDEO,
          true,
        ),
        CommonService.uploadFileAndGetUrl(
          thumbnail,
          FOLDER_TYPE.HOW_TO_VIDEO_THUMBNAIL,
          true,
        ),
      ]);

      const dataToSend = {
        title: title.trim(),
        videoUrl,
        thumbnail: thumbnailUrl,
        status,
      };


      const response = await new Promise((resolve, reject) => {
        POST_API_CALL(
          ENDPOINTS.HOW_TO_VIDEOS.CREATE,
          dataToSend,
          (apiResponse) => {
            console.log("createHowToUsePost response :", apiResponse);
            if (apiResponse.isSuccess) {
              toast.success(apiResponse?.data?.message, { id: toastId });
              resolve(apiResponse.data);
            } else {
              toast.error(apiResponse?.data?.message, { id: toastId });
              reject(new Error("Failed to create how-to video"));
            }
          },
        );
      });

      return response;
    } catch (error) {
      console.error(error);
      toast.error({ id: toastId });
      return null;
    }
  },
  updateHowToVideo: async ({
    id,
    title,
    video,
    thumbnail,
    status,
    previousVideoUrl,
    previousThumbnailUrl,
  }) => {
    const toastId = toast.loading("Updating...");
    try {
      console.log("updateHowToVideo payload :", {
        id,
        title,
        video,
        thumbnail,
        previousVideoUrl,
        previousThumbnailUrl,
      });
      const dataToSend = {
        title: title.trim(),
        status,
      };
      const mediaToDelete = [];

      if (video instanceof File) {
        dataToSend.videoUrl = await CommonService.uploadFileAndGetUrl(
          video,
          FOLDER_TYPE.HOW_TO_VIDEO,
          true,
        );
        if (previousVideoUrl) {
          mediaToDelete.push(previousVideoUrl);
        }
      } else {
        dataToSend.videoUrl = video || "";
        if (!video && previousVideoUrl) {
          mediaToDelete.push(previousVideoUrl);
        }
      }

      if (thumbnail instanceof File) {
        dataToSend.thumbnail = await CommonService.uploadFileAndGetUrl(
          thumbnail,
          FOLDER_TYPE.HOW_TO_VIDEO_THUMBNAIL,
          true,
        );
        if (previousThumbnailUrl) {
          mediaToDelete.push(previousThumbnailUrl);
        }
      } else {
        dataToSend.thumbnail = thumbnail || "";
        if (!thumbnail && previousThumbnailUrl) {
          mediaToDelete.push(previousThumbnailUrl);
        }
      }

      console.log("updateHowToVideo request body :", dataToSend);

      const response = await new Promise((resolve, reject) => {
        PUT_API_CALL(
          ENDPOINTS.HOW_TO_VIDEOS.UPDATE + `?howToUseId=${id}`,
          dataToSend,
          (apiResponse) => {
            console.log("updateHowToVideo response :", apiResponse);
            if (apiResponse.isSuccess) {
              toast.success(apiResponse?.data?.message, { id: toastId });
              resolve(apiResponse.data);
            } else {
              toast.error(apiResponse?.data?.message, { id: toastId });
              reject(new Error("Failed to update how-to video"));
            }
          },
        );
      });

      await Promise.all(
        mediaToDelete.map((fileUrl) =>
          CommonService.deleteS3File(fileUrl).catch((error) => {
            console.error("Failed to delete old how-to media:", fileUrl, error);
          }),
        ),
      );

      return response;
    } catch (error) {
      console.error(error);
      toast.error("Failed to update how-to video.", { id: toastId });
      return null;
    }
  },
};
